// 稱號：依累積場數、胡牌次數、自摸、牌型圖鑑取得
// 對應 docs/PRD-Freemium.md 第 8.3 節；條件只改這裡

import type { IPlayerStats } from './account-service';

export interface ITitle {
  readonly name: string;
  readonly requirement: string; // 給玩家看的條件說明
  readonly reached: (stats: IPlayerStats) => boolean;
  readonly progress: (stats: IPlayerStats) => readonly [number, number]; // [目前, 目標]
}

const by =
  (field: 'rounds' | 'wins' | 'selfDraws' | 'sets', target: number) =>
  (stats: IPlayerStats): readonly [number, number] => [Math.min(stats[field], target), target];
const collected = (stats: IPlayerStats): number => Object.keys(stats.taiTypes).length;

/** 由易到難；目前稱號＝最後一個達成的。 */
export const TITLES: readonly ITitle[] = [
  { name: '麻將新手', requirement: '開始打第一手', reached: () => true, progress: () => [1, 1] },
  {
    name: '牌桌常客',
    requirement: '打滿 50 手',
    reached: (s) => s.rounds >= 50,
    progress: by('rounds', 50),
  },
  {
    name: '胡牌好手',
    requirement: '胡牌 30 次',
    reached: (s) => s.wins >= 30,
    progress: by('wins', 30),
  },
  {
    name: '自摸達人',
    requirement: '自摸 20 次',
    reached: (s) => s.selfDraws >= 20,
    progress: by('selfDraws', 20),
  },
  {
    name: '圖鑑收藏家',
    requirement: '胡過 15 種台型',
    reached: (s) => collected(s) >= 15,
    progress: (s) => [Math.min(collected(s), 15), 15],
  },
  {
    name: '麻將高手',
    requirement: '胡牌 100 次',
    reached: (s) => s.wins >= 100,
    progress: by('wins', 100),
  },
  {
    name: '雀神',
    requirement: '胡牌 300 次',
    reached: (s) => s.wins >= 300,
    progress: by('wins', 300),
  },
];

export const currentTitle = (stats: IPlayerStats): ITitle =>
  [...TITLES].reverse().find((title) => title.reached(stats)) ?? TITLES[0]!;

export const nextTitle = (stats: IPlayerStats): ITitle | null =>
  TITLES.find((title) => !title.reached(stats)) ?? null;
